import { Grid, GridProps, styled } from "@mui/material";

export const CardContainer = styled((props: GridProps) => (
  <Grid item {...props} />
))(() => {
  return {
    display: "flex",
    alignItems: "flex-start",
    flexDirection: "column",

    borderRadius: "0.5rem",
    border: `0.05rem solid #F3F5FB`,
  };
});

export const CardContainerSelected = styled(CardContainer)(() => {
  return {
    border: `0.15rem solid #087E38`,
  };
});

const CardHeader = styled("div")(() => {
  return {
    width: "100%",
    height: "3.5rem",
    padding: "1rem",
    borderTopRightRadius: "0.5rem",
    borderTopLeftRadius: "0.5rem",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  };
});

export const CardLightHeader = styled(CardHeader)(() => {
  return {
    backgroundColor: "#F1F1FB80",
  };
});

export const CardDarkHeader = styled(CardHeader)(() => {
  return {
    backgroundColor: "#2A2E3C",
    color: "#fff",
  };
});

export const CardContent = styled("div")(() => {
  return {
    width: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "column",
    padding: "1rem",
    gap: "1rem",
    overflow: "hidden",
  };
});

export const GapContainer = styled("div")(() => {
  return {
    display: "flex",
    alignItems: "center",
    justifyContent: "start",
    gap: "0.25rem",
  };
});
